// extracted by mini-css-extract-plugin
module.exports = {"mySelect":"MySelect_mySelect__S0rhK"};